import type { IApiClientConfig } from "../services/AxiosApiClientInstance/dtos/AxiosApiClientConfig";

export function getBonusxAuthConfigV1(): IApiClientConfig {
  return {
    baseURL: `${process.env.REACT_APP_AUTH_URL || ""}/auth/api/v1`,
    withCredentials: true,
  };
}

export function getBonusxAuthConfigV2(): IApiClientConfig {
  return {
    baseURL: `${process.env.REACT_APP_AUTH_URL || ""}/auth/api/v2`,
    withCredentials: true,
  };
}
